export default __webpack_public_path__ + "static/media/closet2-1920w.01933dc7.png";